import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { AddUpdatePrenotatiProvaFinaleCommand } from 'src/app/model/command-model';

import { HomeService } from '../../pages/student-page/home/home.service';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-add-student-prova-finale-modal',
  templateUrl: './add-student-prova-finale-modal.component.html',
  styleUrls: ['./add-student-prova-finale-modal.component.css'],
})
export class AddStudentProvaFinaleModalComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  matricola: number;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private homeService: HomeService,
    private sharedService: SharedService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  prenotaProva(idProvaFinale: number, matricolaStudente: number) {
    const command = new AddUpdatePrenotatiProvaFinaleCommand();
    command.idProvaFinale = idProvaFinale;
    command.matricola = matricolaStudente;
    if (!!matricolaStudente) {
      this.homeService.prenotazioneProvaFinale(command).subscribe(
        (result) => {
          this.matricola = null;
          this.ngxSmartModalService
            .getModal('addStudentProvaFinaleModal')
            .close();
          if (result) {
            this.sharedService.openOkModal();
            this.modalSubscribe = this.ngxSmartModalService
              .getModal('okModal')
              .onClose.subscribe((modal: NgxSmartModalComponent) => {
                window.location.reload();
              });
          } else {
            this.sharedService.openKoModal();
          }
        },
        (error) => {
          this.matricola = null;
          this.ngxSmartModalService
            .getModal('addStudentProvaFinaleModal')
            .close();
          console.log('Errore prenotazioneProvaFinale');
        }
      );
    }
  }
}
